import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

var TrustBox = function TrustBox() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx("section", {
    className: "py-4 mx-auto bg-white max-w-7xl",
    children: /*#__PURE__*/_jsx("div", {
      className: "container flex flex-wrap items-center justify-between mx-auto",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col items-center justify-center mx-auto space-y-4 md:flex-row md:mt-8 md:space-x-8 md:space-y-0",
        children: [/*#__PURE__*/_jsx("div", {
          className: "trustpilot-widget",
          "data-locale": "fr-FR",
          "data-template-id": "5419b6a8b0d04a076446a9ad",
          "data-businessunit-id": "622b5b87535b43c191ff812e",
          "data-style-height": "54px",
          "data-style-width": "100%",
          "data-theme": "light",
          "data-min-review-count": "10",
          children: /*#__PURE__*/_jsx("a", {
            href: "https://fr.trustpilot.com/review/yalendar.com",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "text-indigo-500",
            children: "Trustpilot"
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("a", {
            href: "https://www.producthunt.com/posts/yalendar?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-yalendar",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/_jsx(Image, {
              src: "https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=322052&theme=light",
              alt: "Yalendar - Quick setup Online meeting by sharing your availabilities | Product Hunt",
              width: "250",
              height: "54"
            })
          })
        })]
      })
    })
  });
};

export default TrustBox;